import { render, staticRenderFns } from "./famBseg.vue?vue&type=template&id=6b4ddcb0&scoped=true"
import script from "./famBseg.vue?vue&type=script&lang=js"
export * from "./famBseg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4ddcb0",
  null
  
)

export default component.exports